import React from 'react';
import PropTypes from 'prop-types';
import { isPresent } from 'utils/isPresent';

import { useDataFetcherV2 } from 'components/Common/Data/useDataFetcher';

import { fetchFranchisees } from '../../../Resources/Franchises/FranchiseeData';
import FranchiseMenu from '../FranchiseMenu';
import ToolbarOrgLogo from '../ToolbarOrgLogo';

import { planPackageLogoUrls } from './planPackageLogoUrls';

function OrgLogoContainer({ usingHvacPackage = false, orgLogoUrl, isMax }) {
  const [isFetching, { data: franchisees }] = useDataFetcherV2(fetchFranchisees);
  if (!isFetching) return null;

  if (isPresent(franchisees)) return <FranchiseMenu franchisees={franchisees} />;

  const calculateLogoUrl = () => {
    if (!usingHvacPackage) return orgLogoUrl;
    if (!isMax) return planPackageLogoUrls.hvac.dark;

    return orgLogoUrl || planPackageLogoUrls.hvac.light;
  };

  const logoUrl = calculateLogoUrl();

  if (usingHvacPackage || (isMax && logoUrl)) {
    return <ToolbarOrgLogo orgLogoUrl={logoUrl} href="/pro" />;
  }

  return null;
}

OrgLogoContainer.propTypes = {
  usingHvacPackage: PropTypes.bool,
  orgLogoUrl: PropTypes.string,
  isMax: PropTypes.bool,
};

export default OrgLogoContainer;
